<template>
  <div v-if="finished">
    <div class="text-container">
      <div
        v-if="activated && $route.params.guid"
        class="animate__animated"
        :class="{
          animate__zoomInDown: activated && $route.params.guid,
        }"
      >
        <div class="d-flex justify-center">
          <img
            width="260"
            class="cursor-pointer pb-8"
            @click="$router.push('/')"
            alt="Good Casper logo"
            :src="require(`../assets/images/logo/good_casper_white.svg`)"
          />
            <!-- :alt="lang.app.appName" -->
        </div>
        <h2 class="title-2">
          {{ lang.accountActivation.successfullyActivated }}
        </h2>
        <v-btn
          class="with-radius"
          x-large
          outlined
          elevation="0"
          to="/Login?state=login"
          >{{ lang.actions.login }}</v-btn
        >
      </div>
      <div v-else class="animate__animated animate__zoomInDown">
        <div class="d-flex justify-center">
          <img
            width="260"
            class="cursor-pointer pb-8"
            @click="$router.push('/')"
            alt="Good Casper logo"
            :src="require(`../assets/images/logo/good_casper_white.svg`)"
          />
            <!-- :alt="lang.app.appName" -->
        </div>
        <h2 class="title-2">
          {{ lang.accountActivation.invalidActivationLink }}
        </h2>
        <v-btn
          class="with-radius"
          x-large
          outlined
          elevation="0"
          to="/Login?state=login"
          >{{ lang.actions.ok }}</v-btn
        >
      </div>
    </div>
    <div class="text-center show-on-mobile">
      <div
        v-if="activated && $route.params.guid"
        class="animate__animated"
        :class="{
          animate__zoomInDown: activated && $route.params.guid,
        }"
      >
        <div class="d-flex justify-center">
          <img
            width="260"
            class="cursor-pointer pb-8"
            @click="$router.push('/')"
            alt="Good Casper logo"
            :src="require(`../assets/images/logo/good_casper_white.svg`)"
          />
            <!-- :alt="lang.app.appName" -->
        </div>
        <h2 class="title-2 primary--text mt-12">
          {{ lang.accountActivation.successfullyActivated }}
        </h2>
        <v-btn
          class="with-radius mt-4 primary--text"
          x-large
          outlined
          elevation="0"
          to="/Login?state=login"
          >{{ lang.actions.login }}</v-btn
        >
      </div>
      <div v-else class="animate__animated animate__zoomInDown mt-12">
        <div class="d-flex justify-center">
          <img
            width="260"
            class="cursor-pointer pb-8"
            @click="$router.push('/')"
            alt="Good Casper logo"
            :src="require(`../assets/images/logo/good_casper_white.svg`)"
          />
            <!-- :alt="lang.app.appName" -->
        </div>
        <h2 class="title-2 primary--text">
          {{ lang.accountActivation.invalidActivationLink }}
        </h2>
        <v-btn
          class="with-radius primary--text mt-4"
          x-large
          outlined
          elevation="0"
          to="/Login?state=login"
          >{{ lang.actions.ok }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AccountActivation",
  data() {
    return {
      activated: false,
      finished: false,
    };
  },
  computed: {
    ...mapGetters(["rules", "login", "signUp"]),
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  mounted() {
    document.title = "Good Casper - Account Activation";
    this.$store.dispatch("user/logout");
    this.$store
      .dispatch("user/activateAccount", { guid: this.$route.params.guid })
      .then(() => {
        this.finished = true;
        this.activated = true;
      })
      .catch((error) => {
        this.finished = true;
        this.activated = false;
      });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.text-container {
  width: 100%;
}
</style>